import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';
import NRHCPVerificationStyles from './NRHCPVerification.styles';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { VERIFICATION_METHOD_TOOLTIPS } from '../../constants/VerificationMethodConstants';
import { useContext } from 'react';
import { SBOMContext } from '../../pages/NRSBOMTable/NRSBOMDataShare';

const useStyles = makeStyles(NRHCPVerificationStyles);

function NRHCPVerification({ verification, justifyContent = 'center' }) {
  const classes = useStyles();
  const { enabledVerificationMethods } = useContext(SBOMContext);

  const SymIndexFunctionHashingTooltip = ({ verification }) => {
    return (
      <Box sx={{ m: 1 }}>
        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
          <Typography variant={'subtitle2'} sx={{ mr: 1 }}>
            {VERIFICATION_METHOD_TOOLTIPS.MACHINE_LEARNING.TITLE}
          </Typography>
        </Box>
        {enabledVerificationMethods?.functionHashing && (
          <Box sx={{ mb: 1 }}>
            <Typography variant={'subtitle2'}>
              {VERIFICATION_METHOD_TOOLTIPS.FUNCTION_HASHING.TITLE} {verification?.functionHashing && 'Match'} -{' '}
              <Typography variant={'caption'}>{VERIFICATION_METHOD_TOOLTIPS.FUNCTION_HASHING.CONTENT}</Typography>
            </Typography>
          </Box>
        )}
        {enabledVerificationMethods?.symbolIndex && (
          <Box sx={{ mb: 1 }}>
            <Typography variant={'subtitle2'}>
              {VERIFICATION_METHOD_TOOLTIPS.SYMBOL_INDEX.TITLE} {verification?.symIndex && 'Match'} -{' '}
              <Typography variant={'caption'}>{VERIFICATION_METHOD_TOOLTIPS.SYMBOL_INDEX.CONTENT}</Typography>
            </Typography>
          </Box>
        )}
      </Box>
    );
  };

  const HeaderContentTooltip = ({ header, content }) => {
    return (
      <Box>
        <Typography variant={'subtitle2'}>{header}</Typography>
        <Typography variant={'caption'}>{content}</Typography>
      </Box>
    );
  };

  // Check if any ML methods are enabled to show the ML badge
  const showMLBadge = enabledVerificationMethods?.functionHashing || enabledVerificationMethods?.symbolIndex;

  return (
    <div className={classes.container} style={{ justifyContent }}>
      {enabledVerificationMethods?.heuristic && (
        <Tooltip
          title={
            <HeaderContentTooltip header={VERIFICATION_METHOD_TOOLTIPS.HEURISTIC.TITLE} content={VERIFICATION_METHOD_TOOLTIPS.HEURISTIC.CONTENT} />
          }
        >
          <div
            className={clsx(classes.eachContainer, {
              [classes.trueContainer]: verification?.heuristic,
              [classes.falseContainer]: !verification?.heuristic
            })}
          >
            H
          </div>
        </Tooltip>
      )}
      {enabledVerificationMethods?.cryptographicHash && (
        <Tooltip
          title={
            <HeaderContentTooltip
              header={VERIFICATION_METHOD_TOOLTIPS.CRYPTOGRAPHIC_HASH.TITLE}
              content={VERIFICATION_METHOD_TOOLTIPS.CRYPTOGRAPHIC_HASH.CONTENT}
            />
          }
        >
          <div
            className={clsx(classes.eachContainer, classes.middleChild, {
              [classes.trueContainer]: verification?.cryptographic,
              [classes.falseContainer]: !verification?.cryptographic
            })}
          >
            CH
          </div>
        </Tooltip>
      )}
      {enabledVerificationMethods?.packageManager && (
        <Tooltip
          title={
            <HeaderContentTooltip
              header={VERIFICATION_METHOD_TOOLTIPS.PACKAGE_MANAGER.TITLE}
              content={VERIFICATION_METHOD_TOOLTIPS.PACKAGE_MANAGER.CONTENT}
            />
          }
        >
          <div
            className={clsx(classes.eachContainer, classes.middleChild, classes.ml1, {
              [classes.trueContainer]: verification?.package,
              [classes.falseContainer]: !verification?.package
            })}
          >
            PM
          </div>
        </Tooltip>
      )}
      {showMLBadge && (
        <Tooltip title={<SymIndexFunctionHashingTooltip verification={verification} />}>
          <div
            className={clsx(classes.eachContainer, classes.middleChild, classes.ml1, {
              [classes.trueContainer]: verification?.symIndex || verification?.functionHashing,
              [classes.falseContainer]: !verification?.symIndex && !verification?.functionHashing
            })}
          >
            ML
          </div>
        </Tooltip>
      )}
      <Tooltip
        title={
          <HeaderContentTooltip
            header={VERIFICATION_METHOD_TOOLTIPS.USER_MODIFIED.TITLE}
            content={VERIFICATION_METHOD_TOOLTIPS.USER_MODIFIED.CONTENT}
          />
        }
      >
        <div
          className={clsx(classes.eachContainer, {
            [classes.trueContainer]: verification?.userModified,
            [classes.falseContainer]: !verification?.userModified
          })}
        >
          U
        </div>
      </Tooltip>
    </div>
  );
}

export default NRHCPVerification;
